import { BillingDetails } from './billing-details.model';
import { Expert } from './expert.model';
import { PaymentGateway } from './payment-gateway.model';
import { CustomField } from './custom-field.model';

export enum TimeFormat {
  '12h' = 'h:mm a',
  '24h' = 'H:mm',
}

export enum DepositTypeEnum {
  None = 'NONE',
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE',
}

export enum LocationStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export interface LocationOnlineProfiles {
  instagram?: string;
  facebook?: string;
  tiktok?: string;
  whatsapp?: string;
}

export interface LocationGiftCardsConfig {
  values: number[];
  expiryDays: number | null;
}

export interface Location {
  id: number;
  uuid: string;
  businessName: string;
  billingDetails?: BillingDetails;
  currency: string;
  countryCode: string;
  phone: string;
  email: string;
  address: string;
  city: string;
  stateCode?: string;
  zip?: string;
  bookingFee: number;
  absorbFee: boolean;
  giftCardsEnabled: boolean;
  giftCardsConfig: LocationGiftCardsConfig | null;
  allowFullPayments?: boolean;
  experts: Expert[];
  timeZone: string;
  dateFormat: string;
  timeFormat: TimeFormat;
  minBookingTime?: number;
  maxBookingTime?: number;
  themeColor: string;
  depositType: DepositTypeEnum;
  depositValue: number;
  cardOnFileDepositType: DepositTypeEnum;
  cardOnFileDepositValue: number;
  logoImageUuid: string;
  iconImageUuid: string;
  paymentGateways: PaymentGateway[];
  customFields?: CustomField[];
  onlineOrderingEnabled: boolean;
  onlinePaymentsEnabled: boolean;
  beta: boolean;
  demo: boolean;
  status: LocationStatus;
  widgetCustomSubdomainEnabled: boolean;
  partnerType?: LocationPartnerType;
  onlineProfiles?: LocationOnlineProfiles;
}

export enum LocationPartnerType {
  Reseller = 'Reseller',
  Affiliate = 'Affiliate',
}
